import { IBuildings, ISites } from '@llws/lift-entity-interfaces';

/**
 * Whether a site serves the given property. A site serves it when any of these hold:
 * - one of its `sitesHasBuildings` rows targets the property (a row with no `buildingId`
 *   means the site covers every building);
 * - it is a child site (`sourceClientId !== parentClientId`) sourced from the property's
 *   client or child client;
 * - it is a corporate site (`sourceClientId === parentClientId`), which serves every property.
 * @param site The site to check.
 * @param property The property (building) to check against.
 * @returns boolean
 */
export const siteIncludesProperty = (
  site: ISites,
  property?: Pick<IBuildings, 'id' | 'clientId' | 'childClientId'>,
): boolean => {
  // A check for sites_has_buildings record (new)
  if (site.sitesHasBuildings?.some((shb) => !shb.buildingId || shb.buildingId === property?.id)) {
    return true;
  }

  // A check for child client id when we are on a child site against the property (legacy).
  if (site.sourceClientId !== site.parentClientId) {
    return !!property && [property.clientId, property.childClientId].includes(site.sourceClientId ?? -1);
  }

  // A check for corporate site (legacy)
  return site.sourceClientId === site.parentClientId;
};
